import * as React from "react";
import {
    PlasmicLevelsMenu,
    DefaultLevelsMenuProps
} from "./plasmic/main/PlasmicLevelsMenu";

type MenuStates = "levels" | "spaces";

export interface LevelsMenuProps extends DefaultLevelsMenuProps {
    onClose: () => void,
    display: MenuStates,
    empty: boolean
}

function LevelsMenu({onClose, display, empty, ...rest}: LevelsMenuProps) {
    return <PlasmicLevelsMenu
        root={{
            onClick: (e) => e.stopPropagation()
        }}
        state={display}
        empty={empty ? "empty" : undefined}
        closeHandle={{
            onClick: onClose
        }}
        {...rest} />;
}

export default LevelsMenu;
